import { Injectable } from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { AuthService } from '../shared/services';
import { ufaService } from '../pages/UFA/ufe.service';
import moment from 'moment';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root',
})
export class PrintService {

  idkorisnik: any = localStorage.getItem('idsecuser');
  access_token: any = sessionStorage.getItem('token');
  idfirma: any = localStorage.getItem('firma');
  stavke: any = [];
  ufId: any;
  povezani_dokumenti: any = [];
  jednaUFA: any;

  constructor(private ufaService: ufaService, private authService: AuthService) { }

  pdfUFA(uf_id) {
    this.ufId = uf_id;
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      idufa: uf_id,
      uf_status: '0',
      uf_broj: '',
    };

    this.stavke = [];
    this.jednaUFA = null;
    this.ufaService.ufa(podaciZaSlanje).subscribe((res) => {
      if (res.success === true) {
        this.jednaUFA = res.data[0];
        podaciZaSlanje.uf_status = this.jednaUFA.uf_status;
        podaciZaSlanje.uf_broj = this.jednaUFA.uf_broj;
        this.ufaService.ufastavkaPopis(podaciZaSlanje).subscribe((res2) => {
          if (res2.success === true) {
            this.stavke = res2.data;
          }
          this.povezaniDokumenti().then((povDok: any) =>{
            if (povDok) {
              this.ispisUFA();
            }
          });
        });
      }
    });
  }

  povezaniDokumenti(){
    return new Promise((resolve) => {
      let podaciZaSlanje = {
        idkorisnik: this.idkorisnik,
        idfirma: this.idfirma,
        access_token: this.access_token,
        idufa: this.ufId
      }
      this.povezani_dokumenti = [];
      this.ufaService.ufaifaPovezaniDokumenti(podaciZaSlanje).subscribe((res) => {
        //console.log(res);
        if (res.success === true) {
          this.povezani_dokumenti = res.data;
          resolve(1);
        }else{
          resolve(0);
        }
      });
    });
  }

  izracunajRekapitulaciju(stavke) {
    const porezi = {};

    if(stavke) {
      stavke.forEach(stavka => {
        const osnovica = stavka.ps_ulazvr;
        const porez = osnovica * stavka.pz_posto / 100;

        if(!porezi[stavka.pz_posto]) {
          porezi[stavka.pz_posto] = { osnovica: 0, porez: 0};
        }

        porezi[stavka.pz_posto].osnovica += osnovica;
        porezi[stavka.pz_posto].porez += porez;
      });

      return Object.keys(porezi).map(key => ({
        stopa: key,
        ukupanIznos: porezi[key].osnovica + porezi[key].porez,
        osnovica: porezi[key].osnovica.toFixed(2),
        iznosPoreza: porezi[key].porez.toFixed(2),
      }));
    }
  }

  ispisUFA() {
    let hLine = {
      table: {
        widths: ['*'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };

    let ct = [];

    let naziv = '';
    if (this.jednaUFA.pa_naziv) {
      naziv = this.jednaUFA.pa_naziv;
    } else if (this.jednaUFA.pp_naziv) {
      naziv = this.jednaUFA.pp_naziv;
    }

    let adresa = '';
    if (this.jednaUFA.pa_adresa) {
      adresa = this.jednaUFA.pa_adresa;
    } else if (this.jednaUFA.pp_adresa) {
      adresa = this.jednaUFA.pp_adresa;
    }

    let posta = '';
    if (this.jednaUFA.pa_posta) {
      posta = this.jednaUFA.pa_posta;
    } else if (this.jednaUFA.pp_posta) {
      posta = this.jednaUFA.pp_posta;
    }

    let mjesto = '';
    if (this.jednaUFA.pa_mjesto) {
      mjesto = this.jednaUFA.pa_mjesto;
    } else if (this.jednaUFA.pp_mjesto) {
      mjesto = this.jednaUFA.pp_mjesto;
    }

    ct.push({
      columns:
        [
          {
            table: {
              body: [
                [
                  {
                    table: {
                      body: [
                        [
                          {
                            text: ` 
                                Dobavljač: 
                                ${naziv}
                                ${adresa}
                                ${posta}` + ' ' + `${mjesto}`,
                            style: 'subtitle',
                            bold: true,
                          },
                        ],
                        [
                          {
                            text:
                              '\n' +
                              `Datum: ${moment(this.jednaUFA.uf_datum).format('DD.MM.YYYY')}.
                                Valuta plaćanja: ${moment(this.jednaUFA.uf_valuta).format('DD.MM.YYYY.')}
                                Broj dokumenta: ${this.jednaUFA.uf_dokumpar || ''}
                                Broj narudžbe: ${this.jednaUFA.uf_brojnarudzbe || ''}`,
                            style: 'subtitle',
                          },
                        ],
                      ],
                    },
                    layout: 'noBorders',
                  },
                ],
              ],
            },
            layout: 'noBorders',
          },

          {
            table: {
              widths: [250],
              heights: [85],
              body: [
                [
                  {
                    table: {
                      body: [
                        [
                          {
                            text: 'PEKAR d.o.o.',
                            style: 'title',
                          },
                        ],
                        [
                          {
                            text: 'Obrtnička 5',
                            style: 'subtitle',
                          },
                        ],
                        [
                          {
                            text: 'Vinkovci',
                            style: 'subtitle',
                          },
                        ],
                        [
                          {
                            text: 'Društvo upisano kod Trgovačkog suda u Osijeku MBS: 030084282, OIB: 67289965400. Temeljni kapital 5.384.400,00 kn; Predsjednik uprave: Bosiljko Stanić, direktor. Ž.r. Raiffeisen Bank 2484008-1106129914   IBAN: HR4024840081106129914 Ž.r. Otp bank 2407000-1100629330 IBAN: HR4024070001100629330 SWIFT: OTPVHR2X',
                            style: 'details',
                          },
                        ],
                      ],
                    },
                    layout: 'noBorders',
                  },
                ],
              ],
            },
          },
        ],

    });

    ct.push({
      text: '\n',
    });

    ct.push({
      text: '\n' + '\n',
    });

    ct.push({
      text: 'Primka-kalkulacija: ' + this.jednaUFA.uf_broj + '/' + moment(this.jednaUFA.uf_datum).format('YYYY'),
      style: 'mainTitle',
      alignment: 'center',
      margin: [0, 0, 0, 0],
    });

    let brojac = 1;
    let ukupnoKolicina = 0;
    let ukupnoCijena = 0;
    let ukupnoVrijednost = 0;
    let ukupnoIznos = 0;

    ct.push(hLine);

    ct.push({
      table: {
        widths: [10, 27, 100, 15, 40, 40, 30, 40, 27, 40],
        body: [
          [
            { text: 'RB', alignment: 'left' },
            { text: 'Šifra', alignment: 'right' },
            { text: 'Naziv artikla', alignment: 'left' },
            { text: 'Jed.', alignment: 'right' },
            { text: 'Količina', alignment: 'right' },
            { text: 'Bruto cijena', alignment: 'left' },
            { text: 'Rabat %', alignment: 'left' },
            { text: 'Neto cijena', alignment: 'left' },
            { text: 'Porez %', alignment: 'left' },
            { text: 'Neto iznos', alignment: 'left' },
          ],
        ],
      },
      layout: 'lightHorizontalLines',
    });

    ct.push(hLine);

    for (let stavka of this.stavke) {
      let stavkaSifra = '';
      let stavkaNaziv = '';
      let stavkaJedMjere = '';
      let stavkaKolicina = 0;
      let stavkaCijena = 0;
      let stavkaVrijednost = 0;
      let stavkaRabat = '0';
      let stavkaPorez = '0';
      let stavkaIznos = '0';
      let stavkaBrutoCijena = 0;
      let brutoIznos = 0;

      stavkaSifra = stavka.ar_sifra;
      stavkaNaziv = stavka.ar_naziv;
      stavkaJedMjere = stavka.jedinicamjere_JM_SIFRA;
      stavkaKolicina = stavka.ps_ulaz;
      stavkaCijena = stavka.ps_ulazc;
      stavkaVrijednost = stavka.ps_ulazvr;
      stavkaRabat = stavka.ps_postorabata + ' %';
      stavkaPorez = stavka.pz_posto + ' %';
      stavkaIznos = stavka.ps_ulazvr;
      stavkaBrutoCijena = stavka.ps_brutocij;
      brutoIznos = stavkaBrutoCijena * stavkaKolicina;

      ukupnoKolicina += stavka.ps_ulaz;
      ukupnoCijena += stavka.ps_ulazc;
      ukupnoIznos += Number(stavkaIznos);

      ct.push({
        table: {
          widths: [10, 27, 100, 15, 40, 40, 30, 40, 27, 40],
          body: [
            [
              { text: brojac++, alignment: 'left' },
              { text: stavkaSifra, alignment: 'right' },
              { text: stavkaNaziv, alignment: 'left' },
              { text: stavkaJedMjere, alignment: 'right' },
              { text: this.konvertiraj_3decimal(stavkaKolicina), alignment: 'right' },
              { text: this.authService.formatiraj(stavkaBrutoCijena, 5), alignment: 'right' },
              { text: stavkaRabat, alignment: 'right' },
              { text: this.authService.formatiraj(stavkaCijena, 5), alignment: 'right' },
              { text: stavkaPorez, alignment: 'right' },
              { text: this.konvertiraj(stavkaVrijednost), alignment: 'right' }
            ],
          ],
        },
        layout: 'lightHorizontalLines',
      });
    }

    ct.push(hLine);

    ct.push({
      table: {
        widths: [240, 45, 40, 40, 30, 25, 50],
        body: [
          [
            {
              text: 'UKUPNO',
              style: 'tableFooter',
              margin: [205, 0, 0, 0],
              bold: true
            },
            { text: this.konvertiraj_3decimal(ukupnoKolicina), alignment: 'right', style: 'tableFooter', bold: true },
            { text: '', alignment: 'right', style: 'tableFooter' },
            { text: '', alignment: 'right', style: 'tableFooter' },
            { text: '', alignment: 'right', style: 'tableFooter' },
            { text: '', alignment: 'right', style: 'tableFooter' },
            { text: this.konvertiraj(ukupnoIznos) + ' EUR', alignment: 'right', style: 'tableFooter', bold: true },
          ],
        ],
      },
      layout: 'noBorders',
    });

    const rekapitulacijaPoreza = this.izracunajRekapitulaciju(this.stavke);

    ct.push({
      text: '\n\n'
    })

    ct.push({
      table: {
        headerRows: 1,
        widths: ['*',100, 'auto', 'auto', 'auto'],
        body: [
          [
            {text: '', border: [false, false, false, false]},
            {text: 'Rekapitulacija poreza', border: [false, false, false, true]},
            {text: '% poreza', alignment: 'right', margin: [0, 0, 10, 0], border: [false, false, false, true]}, 
            {text: 'Osnovica', alignment: 'right', margin: [0, 0, 10, 0], border: [false, false, false, true]}, 
            {text: 'Iznos poreza', alignment: 'right', margin: [0, 0, 10, 0], border: [false, false, false, true]}
          ],
          ...rekapitulacijaPoreza.map(stavka => [{text: '', border: [false, false, false, false]},{text: '', border: [false, false, false, false]}, {text: stavka.stopa + '%', alignment: 'right', border: [false, false, false, false]}, {text: this.konvertiraj(stavka.osnovica), alignment: 'right', border: [false, false, false, false]}, {text: this.konvertiraj(stavka.iznosPoreza), alignment: 'right', border: [false, false, false, false]},]),          
          [
            { text: '', border: [false, false, false, false]},
            { text: 'Ukupno na računu dobavljača', bold: true, border: [false, true, false, false]},
            { text: '', border: [false, true, false, false]},
            { text: '', bold: true, alignment: 'right', border: [false, true, false, false]},
            { text: this.konvertiraj(rekapitulacijaPoreza.reduce((sum, item) => sum + parseFloat(item.ukupanIznos), 0).toFixed(2)) + ' EUR', bold: true, alignment: 'right', border: [false, true, false, false], style: 'ufaFooter'}
          ]
        ]
      }, 
    });

    ct.push({
      text: '\n' + '\n',
    });

    const skladiste_primka = [(this.povezani_dokumenti.map(item => item.skladiste_dokument))];

    ct.push({
      text: 'Skladište-primka: ' + skladiste_primka,
      style: 'ufaFooter'
    })

    ct.push({
      columns: [
        [
          { text: 'Skladištar:', margin: [0, 20, 0, 10], alignment: 'left' },
          { text: '____________________', alignment: 'left' },
        ],
        [
          { text: 'Izračunao-kontrolirao:', margin: [0, 20, 0, 10], alignment: 'center' },
          { text: this.jednaUFA.korisnik_dodao, alignment: 'center', decoration: 'underline' },
        ],
        [
          { text: 'Knjižio:', margin: [0, 20, 0, 10], alignment: 'right' },
          { text: '____________________', alignment: 'right' },
        ],
      ],
      style: 'ufaFooter',
    });

    ct.push({
      text: 'Dostaviti:\n1. Nabava\n2. Knjigovodstvo\n3. Skladište',
      margin: [0, 20, 0, 0],
      style: 'ufaFooter',
    });

    const docDefinition = {
      info: {
        title: 'ULAZNA FAKTURA: ' + this.jednaUFA.uf_broj + '/' + moment(this.jednaUFA.uf_datum).format('YYYY'),
      },
      content: ct,
      defaultStyle: {
        fontSize: 7.5,
      },
      styles: {
        title: { fontSize: 16, bold: true },
        subtitle: { fontSize: 10 },
        mainTitle: { fontSize: 14, bold: true },
        zaglavljeTablice: { fontSize: 8 },
        stavkeTablice: { fontSize: 8 },
        ufaFooter: { fontSize: 10 },
      }
    };

    pdfMake.createPdf(docDefinition).open();
  }

  konvertiraj(a: any) {
    return this.authService.konvertirajCijenu().konvertiraj(a);
  }

  konvertiraj_3decimal(a: any) {
    return this.authService.konvertiraj().konvertiraj_3decimal(a);
  }
}